import React from 'react';
import PropTypes from 'prop-types';

const Link = ({ href, target, children }) => (
  <a
    data-testid="link-test-id"
    rel="noopener noreferrer"
    href={href || '#'}
    target={target || '_self'}
  >
    {children}
  </a>
);

Link.propTypes = {
  href: PropTypes.string,
  target: PropTypes.string,
  children: PropTypes.node
};

export default Link;
